<template>
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button color="medium" @click="cancel">Cancel</ion-button>
            </ion-buttons>
            <ion-title>Dispositivi</ion-title>
            <ion-buttons slot="end">
                <ion-nav-link :class="{
                    'pointer-events-none': loading || !selected
                }" router-direction="forward" :component="AuditTrapForm" :component-props="{trap: selected}">
                    <ion-button @click="confirm" :disabled="loading || !selected" :strong="true">Confirm</ion-button>
                </ion-nav-link>
            </ion-buttons>
        </ion-toolbar>
        <ion-toolbar>
            <ion-searchbar v-model="search" placeholder="Cerca..."></ion-searchbar>
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="--background: var(--ion-item-background)">
        <template v-if="!loading">
            <ion-item v-for="trap in results" @click="setSelected(trap)"
                      class="relative ion-activatable ripple-parent"
                      style="--inner-padding-bottom: 8px; --inner-padding-top: 8px; --padding-top: 0px; --padding-bottom: 0px;">
                <ion-checkbox :checked="selected ? selected.id == trap.id : false" style="pointer-events: none"
                              :aria-label="`select trap-${trap.id}`" slot="start"></ion-checkbox>
                <div>
                    <ion-label>{{ trap.device_type }}</ion-label>
                    <small v-if="trap.device_type" class="block">
                        <ion-note>
                            Tipologia dispositivo:
                        </ion-note>
                        {{ trap.device_type }}
                    </small>
                    <small v-if="trap.characteristic" class="block">
                        <ion-note>
                            Caratteristica:
                        </ion-note>
                        {{ trap.characteristic }}
                    </small>
                    <small v-if="trap.active_substance" class="block">
                        <ion-note>
                            Principio attivo:
                        </ion-note>
                        {{ trap.active_substance }}
                    </small>
                    <small v-if="trap.capture_limit && trap.capture_limit.acceptability_limits" class="block">
                        <ion-note>
                            Limiti di accettabilità:
                        </ion-note>
                        {{ trap.active_substance }}
                    </small>
                </div>
                <ion-ripple-effect></ion-ripple-effect>
            </ion-item>
        </template>
        <template v-else>
            <ion-item class="costumer-list-item" v-for="_ in [1, 2, 3, 4, 5, 6, 7, 8, 9]">
                <ion-label>
                    <h3>
                        <ion-skeleton-text :animated="true" style="width: 80%;"></ion-skeleton-text>
                    </h3>
                    <p>
                        <ion-skeleton-text :animated="true" style="width: 60%;"></ion-skeleton-text>
                    </p>
                    <p>
                        <ion-skeleton-text :animated="true" style="width: 30%;"></ion-skeleton-text>
                    </p>
                </ion-label>
            </ion-item>
        </template>
    </ion-content>
</template>

<script setup lang="ts">
import {
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonSearchbar,
    IonNavLink,
    IonNote,
    IonRippleEffect,
    IonItem,
    IonLabel,
    IonCheckbox,
    modalController, IonSkeletonText,
} from '@ionic/vue';
import {reactive, ref, watch} from "vue";
import {useTrapsStore} from "@/stores/traps";
import {debounce} from "@/utility";
import {ITrap} from "@/types/trap";
import AuditTrapForm from "@/components/modals/AuditTrapForm.vue";

const trapsStore = useTrapsStore();
const search = ref<string>('');
const loading = ref<boolean>(false);
const results = reactive<ITrap[]>([...trapsStore.traps]);
const selected = ref<ITrap | undefined>(undefined);

watch(search, debounce(async (newSearch, _) => {
    loading.value = true;
    results.length = 0;
    trapsStore.search(newSearch).then((r) => {
        results.push(...r);
        loading.value = false;
    });
}, 500));

const setSelected = (trap: ITrap) => {
    selected.value = trap;
}

const cancel = () => {
    return modalController.dismiss(null, 'cancel');
}
const confirm = () => {
    //return modalController.dismiss(JSON.parse(JSON.stringify(selected.value)), 'confirm');
}
</script>

<style scoped>
.loader {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
